import { Layout } from "antd"
import { Footer, Header } from "antd/es/layout/layout"
import { Outlet } from "react-router"
import logo from "../assets/logo.svg"
import "./Layout.css"

const AuthLayout = () => {
    return (
        <Layout className="layout">
            <Header className="header">
                <img src={logo} width={"120px"} height={"45px"}/>
            </Header>
            <div className="outlet-container">
            <Outlet />
            </div>
            <Footer className="footer"/>
        </Layout>
    )
}

export default AuthLayout